import { createFileRoute } from "@tanstack/react-router";
import { legacyRedirectTo } from "@/lib/legacy-redirect";

// Legacy URL /settings → redirect to /app/settings.
export const Route = createFileRoute("/settings/")({
  beforeLoad: legacyRedirectTo("/app/settings"),
  component: () => null,
});
